import { DropDownNoSelection, DropDownResult, isDropDownResult, TypeOrArray } from '@myosh/odin-components';

interface HandleHFDropdownChangeInterface {
  value: TypeOrArray<DropDownResult> | DropDownNoSelection | undefined;
  onChange: (...event: unknown[]) => void;
  clearValueCallback?: () => void;
}

/**
 * A helper function to handle dropdown changes in react-hook-form.
 * It checks if the selected value is a valid DropDownResult and calls the onChange handler accordingly.
 * If the value is not valid, it calls onChange with undefined and optionally executes a clearValueCallback.
 *
 * @param {TypeOrArray<DropDownResult> | DropDownNoSelection | undefined} value - The selected value from the dropdown.
 * @param {(...event: unknown[]) => void} onChange - The onChange handler from react-hook-form.
 * @param {() => void} [clearValueCallback] - An optional callback to execute when the value is cleared.
 */

export const handleHFDropdownChange = ({ value, onChange, clearValueCallback }: HandleHFDropdownChangeInterface) => {
  if (isDropDownResult(value)) {
    onChange(value);
  } else {
    onChange(undefined);
    clearValueCallback?.();
  }
};
